<template>
  <li
    class="catalog-item card__item fadeInSimple"
    :class="{
      'col-4': display == 'grid',
      'col-12': display != 'grid',
    }"
  >
    <div
      class="position-relative"
      :class="{
        'col-4': display != 'grid',
        'col-12': display == 'grid',
      }"
    >
      <button
        type="button"
        class="btn btn--tertiary btn--black type-small quick-view js-show-quick-view"
        aria-haspopup="dialog"
        @click="toggleModal"
      >
        Quick View
      </button>
      <a :href="href" class="card__item--image add-bottom-margin no-underline">
        <div class="card__item--cover add-bottom-margin">
          <div v-if="hasImage" class="card__item-contents">
            <img
              :src="imgThumbnailUrl"
              :alt="result.Name"
              class="catalog-item__img b-lazy b-loaded width-100"
            />
          </div>
          <div
            v-if="!hasImage && catalog == 'shop'"
            class="card__item-contents"
          >
            <img
              src="/images/default-card.png"
              :alt="result.Name"
              class="catalog-item__img"
            />
          </div>
          <div
            v-if="!hasImage && catalog == 'perform'"
            class="card__item-contents color-black flex flex--column flex--between padding-sides-m"
            :class="customColor"
          >
            <div class="card__item-container">
              <div
                class="image-monogram-secondary-white add-bottom-margin align-l"
              >
                <img
                  src="/images/concord-monogram.svg?v2"
                  width="32"
                  height="32"
                  alt=""
                />
              </div>
              <h3 class="card__item-title type-card-large no-bottom-margin">
                {{ result.Name | truncate(55) }}
              </h3>
              <p
                class="card__item--cover-author type-regular"
                v-if="result.Authors.length > 0"
              >
                <template v-if="result.Authors.length <= 2">
                  <span
                    class="type-regular type-circular display-inline"
                    v-for="(name, index) in result.Authors"
                    :key="name + index"
                  >
                    {{ name.FirstName }} {{ name.LastName
                    }}<span v-if="index !== result.Authors.length - 1">, </span>
                  </span>
                </template>
                <span
                  class="type-regular type-circular display-inline"
                  v-else-if="result.Authors.length > 2"
                >
                  Multiple Authors
                </span>
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div
      class="catalog-item__info card__item-description"
      :class="{
        'col-md-8 col-12': display != 'grid',
        'col-12': display == 'grid',
      }"
    >
      <a
        :href="href"
        class="type-h5 color-off-black no-underline add-x-small-bottom-margin"
        :class="{ 'list-title': display == 'list' }"
      >
        {{ result.Name | truncate(66) }}
      </a>
      <p class="type-small" v-if="display == 'grid'">
        {{ authors }}
        <span
          class="type-italic display-block"
          v-if="result.TitleTypeOfPlayAndGenre"
          >{{ result.TitleTypeOfPlayAndGenre }}</span
        >
        <span class="type-italic display-block" v-if="result.TitleCasting">{{
          result.TitleCasting
        }}</span>
        <span class="type-bold display-block" v-if="catalog == 'shop'">{{
          shopProductPrice
        }}</span>
      </p>
      <p class="type-small" v-if="display == 'list'">
        <span v-for="(author, index) in result.Authors" :key="index">
          <a
            :href="getAuthorHref(author)"
            class="type-regular type-link type-circular-italic"
          >
            {{ author.FirstName }} {{ author.LastName }} </a
          ><span v-if="index != result.Authors.length - 1">, </span>
        </span>
        <span
          v-if="result.TitleTypeOfPlayAndGenre"
          class="type-regular display-block"
        >
          <span class="type-circular-italic">{{
            result.TitleTypeOfPlayAndGenre
          }}</span>
          /
          <span class="type-circular-italic">{{ result.TitleCasting }}</span>
        </span>
      </p>
      <p
        class="color-off-black type-regular"
        v-if="catalog !== 'shop' && display == 'list'"
        v-html="decodeHtmlEntities(result.ShortDescription)"
      ></p>
      <p
        v-if="catalog == 'perform' && display == 'list'"
        class="add-large-top-margin"
      >
        <a class="btn btn--small" :href="href">View Full Page</a>
        <a
          class="btn btn--secondary btn--small"
          :href="licenceRequestPath"
          v-if="result.Licensable"
          >Request License</a
        >
      </p>
      <!-- <p v-if="display == 'list'" class="flex flex--between">
        <a class="btn  btn--small" :href="href">View Full Page</a>
        <a class="btn btn--secondary btn--small" :href="licenceRequestPath">Request License</a>
      </p> -->
      <div
        v-if="catalog == 'shop' && display == 'list'"
        class="catalog-item__variants"
      >
        <ul class="unstyled-list catalog-item__top-variants">
          <li v-for="item in topVariants" :key="item.Id">
            <a
              :href="getVariantHref(item)"
              class="type-link no-underline strict flex flex--align-center flex--between"
            >
              <span class="flex flex--align-baseline">
                <span class="type-h5 display-inline-block margin-right-s">{{
                  item.Name
                }}</span>
                <span class="type-x-small">ISBN: {{ item.Sku }}</span>
              </span>
              <span class="type-x-small type-bold align-r">{{
                item.Price
              }}</span>
            </a>
          </li>
        </ul>
        <span class="display-inline-block type-small" v-if="theRest.length > 0"
          >Also available as:</span
        >
        <ul class="unstyled-list inline-list type-x-small display-inline-block">
          <li v-for="item in theRest.slice(0, 2)" :key="item.Id">
            <a :href="getVariantHref(item)" class="type-link">{{ item.Name }}</a
            >,
          </li>
          <li>
            <a
              :href="href"
              class="type-link"
              v-if="result.ProductVariants.length > 4"
              >See All</a
            >
          </li>
        </ul>
        <p v-if="result.ProductVariants[0] !== undefined">
          <AddToWishlist
            :productId="result.Id"
            :productVariantId="result.ProductVariants[0].Id"
            :wishlist-enum="catalog"
          />
        </p>
      </div>
    </div>
    <div
      class="modal quick-view-modal"
      v-if="modalOpen && display == 'grid'"
      :aria-hidden="isHidden"
    >
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div
          class="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-1-title"
          :aria-describedby="'modal-' + result.Id"
        >
          <div role="document">
            <header class="modal__header">
              <button
                type="button"
                class="modal__close"
                aria-label="Close modal"
                @click="toggleModal"
                aria-controls="modal__container1"
              ></button>
            </header>
            <main
              class="modal__content flex add-large-bottom-padding"
              :id="'modal-' + result.Id"
            >
              <QuickViewModal :product="result.Id" :catalog="catalog" />
            </main>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AddToWishlist from './AddToWishlist.vue';
import QuickViewModal from './QuickViewModal.vue';

// import { GET_CATALOG_ITEMS } from '../vuex/modules/catalog/mutations';

export default {
  name: 'CatalogProduct',
  props: ['result', 'catalog'],
  components: {
    AddToWishlist,
    QuickViewModal,
  },
  data() {
    return {
      templateUrl: '',
      pathPrefix: '',
      authors: '',
      modalOpen: false,
      quickviewAuthors: null,
      theRest: [],
      productType: 1,
    };
  },
  mounted() {
    // set prefix for urls based on the passed catalog.
    // so that we can build links to scripts or titles
    this.pathPrefix = this.catalog == 'perform' ? 'p' : 's';
    this.authors =
      this.result.Authors.length <= 2
        ? this.buildAuthors(this.result.Authors)
        : 'Multiple Authors';
    this.quickviewAuthors = this.buildAuthorLinks(this.result.Authors);

    this.productType = this.getProductType();
  },
  methods: {
    // from https://laracasts.com/discuss/channels/general-discussion/escape-html-characters-with-vuejs
    decodeHtmlEntities(str) {
      var txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    },

    getProductType() {
      let productType = null;
      switch (this.result.ProductTypeId) {
        case 1:
          productType = 'card-script';
          break;
        case 3:
          productType = 'card-book';
          break;
        case 4:
          productType = 'card-cd';
          break;
        case 5:
          productType = 'card-logo';
          break;
        case 6:
          productType = 'card-music';
          break;
        case 7:
          productType = 'card-poster';
          break;
        case 8:
          productType = 'card-supplemental';
          break;
        default:
          productType = 'card-script';
          break;
      }

      return productType;
    },

    // if there are two or less authors, return a formatted string
    buildAuthors(authors) {
      const auths = authors.map((author) => {
        return `${author.FirstName} ${author.LastName}`;
      });
      return auths.join(', ');
    },

    // helper method to build a list of author links as a string.
    buildAuthorLinks(authors) {
      const auths = authors.map((author) => {
        return `<a href="">${author.LastName}, ${author.FirstName}`;
      });
      return auths.join(', ');
    },

    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },

    getAuthorHref(author) {
      return `/a/${author.Id}/${author.SeName}`;
    },

    getVariantHref(variant) {
      return `/s/${this.result.Id}/${this.result.SeName}?variantId=${variant.Id}`;
    },
  },

  filters: {
    truncate(string, value) {
      if (string.length > value) {
        return `${string.substring(0, value)}...`;
      } else {
        return string;
      }
    },
  },

  computed: {
    ...mapState({
      display: (state) => state.catalogStore.display,
    }),

    ...mapGetters(['currencySymbol']),

    // returns the href value to link to the current product page/
    href() {
      return `/${this.pathPrefix}/${this.result.Id}/${this.result.SeName}`;
    },

    licenceRequestPath() {
      return `${window.env.ZOHRAB_LICENSE_DOMAIN}/performance-license/license?productId=${this.result.Id}`;
    },

    // TODO - this is brittle. We need a better solution, plus a fallback.
    // Also, the height isn't quite big enough, so the images are fuzzy.
    imgThumbnailUrl() {
      const img = this.result.ProductImages.find(
        (img) => img.Type.toLowerCase() == this.catalog
      );
      return typeof img !== 'undefined'
        ? img.ImageUrl
        : '/images/default-card.png';
    },

    // outputs the first few links for produts or variants, and sets the rest
    // into an array. If it gets populated, then we show that in the template
    // under a "show more" type of thing.
    topVariants() {
      const variants = this.result.ProductVariants.filter(
        (val) => val.Published == true && val.Deleted == false
      );
      let output = [];
      let theRest = [];

      variants.forEach((variant) => {
        if (
          variant.Name == 'Acting Edition' ||
          variant.Name.includes('ePlay')
        ) {
          output.push(variant);
        } else {
          theRest.push(variant);
        }
      });

      // if we still have room, add the next one
      theRest.forEach((variant, index) => {
        if (output.length < 2) {
          output.push(variant);
          theRest.splice(index, 1);
        }
      });

      this.theRest = [...theRest];

      return output;
    },

    hasImage() {
      const img = this.result.ProductImages.find(
        (img) => img.Type.toLowerCase() == this.catalog
      );
      return typeof img !== 'undefined' ? true : false;
    },

    customColor() {
      // console.log(this.result.FeaturedColor, 'featured');
      const bg = `bg-color-${
        this.result.FeaturedColor !== null && this.result.FeaturedColor !== ''
          ? this.result.FeaturedColor
          : 'sky-blue-tint'
      }`;
      const font =
        this.result.FeaturedColor !== null &&
        this.result.FeaturedColor !== 'white'
          ? 'color-off-black'
          : 'color-off-black';
      return `${bg} ${font}`;
    },

    fontColor() {
      return this.result.FeaturedColor !== null &&
        this.result.FeaturedColor !== 'white'
        ? 'color-off-black'
        : 'color-off-black';
    },

    isHidden() {
      return this.modalOpen ? 'false' : 'true';
    },

    shopProductPrice() {
      const sym = this.currencySymbol;
      if (this.result.ProductVariants.length < 1) {
        return '';
      }
      const numbers = this.result.ProductVariants.map((item) =>
        Number(item.Price.replace(/(^\$|^\£|,)/g, ''))
      ).sort((a, b) => a - b);
      if (numbers.length > 1) {
        const lowest = numbers[0];
        const highest = numbers[numbers.length - 1];
        return `${sym}${lowest} - ${sym}${highest}`;
      } else {
        return `${sym}${numbers[0]}`;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogProduct.vue